import { Component, Input } from '@angular/core';
import { TreeWrapperNode } from '../models/tree-wrapper-node.model';

/**
 * Componente placeholder para drag & drop
 * Mantiene compatibilidad con el template original pero no implementa funcionalidad
 */
@Component({
    selector: 'tree-node-drop-slot',
    template: '',
    styles: [],
    standalone: false
})
export class TreeNodeDropSlotComponent {
  @Input() dropIndex: number;
  @Input() node: TreeWrapperNode;
}

